export const translations = {
  de: {
    nav: {
      destinations: 'Reiseziele',
      calculator: 'Kalkulator',
      packing: 'Packliste',
      blog: 'Blog',
      recipes: 'Rezepte',
      lounges: 'Lounges',
      about: 'Über Uns'
    },
    hero: {
      title: 'Entdecke die Welt',
      titleGradient: 'on a Budget',
      subtitle: 'Aktive Abenteuer, kulturelle Erlebnisse & insider Spartipps für über 20 Destinationen weltweit. Von Tauchen auf den Philippinen bis Trekking in den Alpen.',
      ctaDestinations: 'Reiseziele entdecken',
      ctaCalculator: 'Reise kalkulieren',
      stat1: 'Destinationen',
      stat2: 'Flughäfen',
      stat3: 'Budget-Tipps'
    },
    destinations: {
      title: 'Unsere Reiseziele',
      subtitle: 'Entdecke über 20 handverlesene Destinationen mit echten Insider-Tipps',
      all: 'Alle',
      details: 'Details anzeigen',
      nomadScore: 'Nomad Score',
      airports: 'Flughäfen',
      bestTime: 'Beste Reisezeit',
      livingCosts: 'Ø Lebenskosten'
    },
    calculator: {
      title: 'Reisekalkulator',
      subtitle: 'Berechne deine Reisekosten basierend auf aktuellen Durchschnittspreisen 2025',
      destination: 'Reiseziel',
      duration: 'Reisedauer (Tage)',
      transport: 'Anreise zum Flughafen',
      publicTransport: 'Öffentliche Verkehrsmittel',
      ownCar: 'Eigenes Auto (mit Parkgebühren)',
      accommodation: 'Unterkunftsniveau',
      budget: 'Budget',
      mid: 'Mittel',
      comfort: 'Komfort',
      flightPrice: 'Flugpreis (€)',
      breakdown: 'Kostenaufstellung',
      flight: 'Flug',
      parking: 'Parkgebühren',
      fuel: 'Benzin',
      tolls: 'Maut',
      tunnel: 'Tunnel',
      publicToAirport: 'ÖPNV zum Flughafen',
      publicFromAirport: 'ÖPNV vom Zielflughafen',
      accommodationPerNight: 'Unterkunft pro Nacht',
      dailyTransport: 'Tägliche Fortbewegung',
      foodPerDay: 'Essen & Getränke pro Tag',
      total: 'Gesamtkosten',
      days: 'Tage',
      perDay: 'pro Tag',
      note: 'Alle Werte basieren auf Durchschnittskosten 2025 und sind anpassbar. Nutze die Felder, um deine eigenen Preise einzutragen.'
    },
    blog: {
      title: 'Travel Blog',
      subtitle: 'Reiseberichte, Tipps & Erfahrungen aus erster Hand',
      search: 'Blog durchsuchen...',
      allCountries: 'Alle Länder',
      readMore: 'Weiterlesen',
      noResults: 'Keine Blogbeiträge gefunden',
      resetFilters: 'Filter zurücksetzen',
      ctaTitle: 'Bleib auf dem Laufenden',
      ctaText: 'Melde dich für unseren Newsletter an und erhalte neue Blogbeiträge direkt in dein Postfach',
      subscribe: 'Anmelden',
      emailPlaceholder: 'Deine E-Mail'
    },
    recipes: {
      title: 'Internationale Rezepte',
      subtitle: 'Entdecke authentische Gerichte aus unseren Reiseländern - zum Nachkochen für zuhause',
      search: 'Rezepte durchsuchen...',
      allContinents: 'Alle Kontinente',
      cookingTime: 'Kochzeit',
      difficulty: 'Schwierigkeit',
      servings: 'Portionen',
      viewRecipe: 'Rezept anzeigen',
      easy: 'Einfach',
      medium: 'Mittel',
      hard: 'Fortgeschritten'
    },
    footer: {
      tagline: 'Dein Guide für aktive Abenteuer und Budget-Reisen rund um die Welt',
      travel: 'Reisen',
      partners: 'Partner',
      info: 'Informationen',
      newsletter: 'Newsletter',
      newsletterText: 'Erhalte die besten Reisetipps & Deals direkt in dein Postfach',
      copyright: 'Made with',
      disclosure: 'Affiliate-Links: Bei Buchungen über unsere Partner-Links erhalten wir eine Provision - für dich entstehen keine Mehrkosten.'
    }
  },
  en: {
    nav: {
      destinations: 'Destinations',
      calculator: 'Calculator',
      packing: 'Packing',
      blog: 'Blog',
      recipes: 'Recipes',
      lounges: 'Lounges',
      about: 'About Us'
    },
    hero: {
      badge: 'Your Travel Guide 2025',
      title: 'Discover the World',
      titleGradient: 'on a Budget',
      subtitle: 'Active adventures, cultural experiences & insider money-saving tips for over 20 destinations worldwide. From diving in the Philippines to trekking in the Alps.',
      ctaDestinations: 'Explore Destinations',
      ctaCalculator: 'Calculate Trip',
      stat1: 'Destinations',
      stat2: 'Airports',
      stat3: 'Budget Tips'
    },
    destinations: {
      title: 'Our Destinations',
      subtitle: 'Discover over 20 hand-picked destinations with genuine insider tips',
      all: 'All',
      details: 'View Details',
      nomadScore: 'Nomad Score',
      airports: 'Airports',
      bestTime: 'Best Time',
      livingCosts: 'Avg Living Costs'
    },
    calculator: {
      title: 'Travel Calculator',
      subtitle: 'Calculate your travel costs based on current 2025 average prices',
      destination: 'Destination',
      duration: 'Trip Duration (Days)',
      transport: 'Transport to Airport',
      publicTransport: 'Public Transport',
      ownCar: 'Own Car (with parking fees)',
      accommodation: 'Accommodation Level',
      budget: 'Budget',
      mid: 'Mid-range',
      comfort: 'Comfort',
      flightPrice: 'Flight Price (€)',
      breakdown: 'Cost Breakdown',
      flight: 'Flight',
      parking: 'Parking',
      fuel: 'Fuel',
      tolls: 'Tolls',
      tunnel: 'Tunnel',
      publicToAirport: 'Public Transport to Airport',
      publicFromAirport: 'Public Transport from Airport',
      accommodationPerNight: 'Accommodation per Night',
      dailyTransport: 'Daily Transport',
      foodPerDay: 'Food & Drinks per Day',
      total: 'Total Cost',
      days: 'Days',
      perDay: 'per Day',
      note: 'All values are based on 2025 average costs and are adjustable. Use the fields to enter your own prices.'
    },
    blog: {
      title: 'Travel Blog',
      subtitle: 'Travel reports, tips & first-hand experiences',
      search: 'Search blog...',
      allCountries: 'All Countries',
      readMore: 'Read More',
      noResults: 'No blog posts found',
      resetFilters: 'Reset Filters',
      ctaTitle: 'Stay Updated',
      ctaText: 'Subscribe to our newsletter and receive new blog posts directly in your inbox',
      subscribe: 'Subscribe',
      emailPlaceholder: 'Your Email'
    },
    recipes: {
      title: 'International Recipes',
      subtitle: 'Discover authentic dishes from our travel destinations - recreate them at home',
      search: 'Search recipes...',
      allContinents: 'All Continents',
      cookingTime: 'Cooking Time',
      difficulty: 'Difficulty',
      servings: 'Servings',
      viewRecipe: 'View Recipe',
      easy: 'Easy',
      medium: 'Medium',
      hard: 'Advanced'
    },
    footer: {
      tagline: 'Your guide for active adventures and budget travel around the world',
      travel: 'Travel',
      partners: 'Partners',
      info: 'Information',
      newsletter: 'Newsletter',
      newsletterText: 'Get the best travel tips & deals directly in your inbox',
      copyright: 'Made with',
      disclosure: 'Affiliate Links: We receive a commission for bookings through our partner links - at no extra cost to you.'
    }
  }
};

export const useTranslation = (language) => {
  return (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      value = value?.[k];
    }
    
    return value || key;
  };
};
